import { defineComponent as _defineComponent } from 'vue'
import ParallaxWrapper from '@components/ParallaxWrapper.vue';

import FeatureDetailsBlock from './FeatureDetailsBlock.vue';
import MainSectionPanel from './MainSectionPanel.vue';

import { IconDefinition } from '@icons/core';
import { faClock } from '@icons/regular/faClock';
import { faDroneFront } from '@icons/regular/faDroneFront';
import { faGamepadModern } from '@icons/regular/faGamepadModern';

interface RotatingIcon {
  key: string;
  icon: IconDefinition;
}

const ROTATING_ICON: RotatingIcon[] = [
  { key: 'a', icon: faClock },
  { key: 'b', icon: faDroneFront },
  { key: 'c', icon: faGamepadModern },
];

const __default__ = { name: 'MainSectionProficiency' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return { __sfc: true,ROTATING_ICON, ParallaxWrapper, FeatureDetailsBlock, MainSectionPanel }
}

})